/**
 * InfinitSales - WhatsApp Business Template Service
 * API service for managing Meta message templates
 */
import api from './api';

const BASE = '/api/wa-business/templates/';

class TemplateService {
  /** List all templates for the user's WABA */
  async list() {
    const response = await api.get(BASE);
    return response.data;
  }

  /** Create a new simple text template */
  async create(data) {
    const response = await api.post(BASE, data);
    return response.data;
  }

  /** Delete a template by name */
  async delete(name) {
    const response = await api.delete(`${BASE}${name}`);
    return response.data;
  }

  /** Send a template message to a phone number.
   *  extra: { body_params: ["Ana", ...], header_param: {type, text|link},
   *           button_params: {"1": "..."}, language } — só para template com
   *  variáveis; omitir para template simples. */
  async send(templateName, phone, extra = {}) {
    const response = await api.post(`${BASE}${templateName}/send`, { phone, ...extra });
    return response.data;
  }

  /** Prévia do template com os valores resolvidos para um contato, sem
   *  enviar. payload: { phone, contact_name, body_params, header_param,
   *  button_params }. Só responde com TEMPLATE_PARAMS_UI_ENABLED. */
  async preview(templateName, payload = {}) {
    const response = await api.post(`${BASE}${templateName}/preview`, payload);
    return response.data;
  }

  /** Get paginated send logs for a template */
  async getLogs(templateName, { page = 1, pageSize = 20, phone = '' } = {}) {
    const params = { page, page_size: pageSize };
    if (phone) params.phone = phone;
    const response = await api.get(`${BASE}${templateName}/logs`, { params });
    return response.data;
  }
}

const templateService = new TemplateService();
export default templateService;
